// client/src/pages/Contact.js

import React, { useState } from 'react';
import axios from 'axios';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/contact`, {
        name: form.name,
        email: form.email,
        message: form.message
      });

      alert('Thanks for contacting us. We’ll respond soon!');
      setForm({ name: '', email: '', message: '' });
    } catch (err) {
      console.error('Error submitting contact form:', err);
      alert('Failed to send message. Please try again later.');
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-4 mt-16">
      <h1 className="text-3xl font-bold mb-6">Contact Us</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1 font-medium">Name</label>
          <input
            type="text"
            name="name"
            className="border p-2 w-full"
            value={form.name}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label className="block mb-1 font-medium">Email</label>
          <input
            type="email"
            name="email"
            className="border p-2 w-full"
            value={form.email}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label className="block mb-1 font-medium">Message</label>
          <textarea
            name="message"
            className="border p-2 w-full"
            rows={5}
            value={form.message}
            onChange={handleChange}
            required
          />
        </div>
        <button
          type="submit"
          className="bg-primaryGreen text-white px-4 py-2 rounded hover:bg-green-500"
        >
          Send
        </button>
      </form>
    </div>
  );
}
